/* stylelint-disable no-descending-specificity */
import { ArrowRightIcon } from '@root/styles/icons';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import getContrastFontColor from '@utils/getContrastFontColor';

export const StyledArrow = styled(ArrowRightIcon)`
  color: ${({ theme }) => theme.defaultColors.grey};
`;

export const StyledDateRangePickerWrapper = styled.div`
  display: inline-flex;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;

  ${media.xl`
    width: auto;
  `}

  .DayPicker__withBorder {
    ${media.md`
      box-shadow: 0px 10px 20px #00000029;
      border-radius: 8px;
    `}
  }
  .SingleDatePickerInput {
    min-height: 56px;
    min-width: 190px;

    ${media.md`
      min-height: initial;
    `}
  }

  .DateRangePickerInput,
  .SingleDatePickerInput {
    display: flex;
    align-items: center;
    padding: 2px 30px 2px 15px;
    font-family: ${({ theme }) => theme.bodyFont};

    &_arrow {
      display: flex;
      color: ${({ theme }) => theme.defaultColors.grey};
    }

    &__withBorder {
      border-radius: 3px;
      border-color: ${({ theme }) => theme.defaultColors.grey};
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: calc(50% - 2px);
      right: 12px;
      width: 0px;
      height: 0px;
      border-style: solid;
      border-width: 4px 3px 0px;
      border-color: ${({ theme }) => theme.defaultColors.fontPrimary} transparent transparent;
      margin-left: 10px;
    }
  }

  .DateInput {
    &_input {
      font-size: 16px;
      line-height: 20px;
      font-weight: ${({ theme }) => theme.fontWeights.normal};
      padding: 10px 0;
      border-bottom: 0;
      border-radius: 3px;
      font-family: inherit;
      color: ${({ theme }) => theme.defaultColors.fontPrimary};
      cursor: pointer;

      &__focused {
        border: none;
      }
    }
  }

  .DateRangePicker {
    &_picker {
      z-index: 10;
    }
  }

  .DayPickerNavigation {
    top: 24px !important;
    left: -11px !important;
    &_button {
      width: 2px;
      border: 0;
    }
  }

  .CalendarMonth_caption {
    font-size: 16px;
    font-family: ${({ theme }) => theme.bodyFont};
    color: ${({ theme }) => theme.defaultColors.fontPrimary};
  }

  .CalendarMonth_caption > strong {
    font-weight: 600;
  }

  .CalendarMonth_table {
    margin-top: 16px;
  }

  .DayPicker_weekHeader_ul,
  .CalendarDay {
    font-size: 14px;
    font-weight: 600;
  }

  .CalendarDay__hovered_span + .CalendarDay__selected_end,
  .CalendarDay__selected_span + .CalendarDay__selected_end {
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 20px;
      height: 49px;
      z-index: -1;
      background: ${({ theme }) => theme.customColors.tertiary};
    }

    &:after {
      content: '';
      position: absolute;
      border-radius: 50%;
      width: 48px;
      height: 48px;
      ${media.md`
        width: 54px;
        height: 54px;
      `}
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
      background: ${({ theme }) => theme.customColors.primary};
    }
  }

  .DayPickerNavigation {
    display: flex;
    justify-content: space-between;
    top: 18px;
    padding: 0 30px;
  }

  .DayPickerNavigation_button {
    color: #444;
  }

  .CalendarDay {
    border: 0;
    color: ${({ theme }) => theme.defaultColors.fontPrimary};

    &__selected,
    &__selected:hover {
      border-radius: 100%;
      border: 0;
      background: ${({ theme }) => theme.customColors.primary}!important;
      opacity: 1 !important;
      z-index: 1;
      position: relative;
      color: ${({ theme }) =>
        `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
      & > div {
        color: ${({ theme }) =>
          `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
      }
      &:after {
        content: '';
        position: absolute;
        border-radius: 50%;
        width: 48px;
        height: 48px;
        ${media.md`
          width: 54px;
          height: 54px;
        `}
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
        background: ${({ theme }) => theme.customColors.primary};
      }
    }

    &__selected_span,
    &__selected_span:hover {
      border: 0;
      background: ${({ theme }) => `${theme.customColors.primary}CC!important`};
      color: ${({ theme }) =>
        `${getContrastFontColor(
          theme.defaultColors.fontPrimary,
          theme.customColors.primary
        )}!important`};
      border-radius: 0 !important;
      & > div {
        color: ${({ theme }) =>
          `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
      }
    }

    &__hovered_span.CalendarDay__before_hovered_end {
      background: inherit !important;

      &:hover {
        background: ${({ theme }) => theme.defaultColors.lightGrey} !important;
      }
    }

    &__hovered_span,
    &__hovered_span:hover {
      border: 0;
      background: ${({ theme }) => theme.customColors.tertiary};
    }

    &__blocked_out_of_range {
      color: ${({ theme }) => theme.defaultColors.lightGrey};
    }

    &__blocked_calendar,
    &__blocked_calendar:active,
    &__blocked_calendar:hover,
    &__blocked_calendar:before,
    &__blocked_calendar:after {
      background: none;
      border: none;
      color: initial;
      opacity: 0.2;
    }
    &__highlighted_calendar {
      color: ${({ theme }) => `${theme.defaultColors.fontPrimary}`};
      border-radius: 100%;
      background: ${({ theme }) => `${theme.defaultColors.lightGrey}`};
    }
  }

  .CalendarDay__selected_start + .CalendarDay__selected_span {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: -20px;
      top: 0;
      width: 20px;
      height: 49px;
      z-index: 0;
      background: ${({ theme }) => `${theme.customColors.primary}CC`};
    }
  }

  .CalendarDay__selected_start + .CalendarDay__hovered_span {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: -20px;
      top: 0;
      width: 20px;
      height: 49px;
      z-index: 0;
      background: ${({ theme }) => theme.customColors.tertiary};
    }
  }

  .CalendarDay__selected_span + .CalendarDay__selected_end:before {
    background: ${({ theme }) => `${theme.customColors.primary}CC`};
  }

  .DateInput_fang {
    display: none;
  }
`;
